import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import ParseHtml from '../../components/common/ParseHtml';
import SessionExpired from '../../components/common/SessionManager/SessionExpired';
import withLocalization from '../../components/hoc/withLocalization';
import { IDLE_TIMEOUT } from '../../redux/middleware';
import { RootState } from '../../redux/rootReducer';
import { clearAuthInfoFromStorage } from '../../util';
import { getHumanReadableTime } from '../../util/date';
import { OFFER_CONTACT_INFO_PATH, OFFER_ELIGIBILITY_PATH, OFFER_REVIEW_PATH } from '../../util/strings';
import { setNavigation } from './sessionManagerSlice';

const SessionManager: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const [showMessage, setshowMessage] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [timerDuration, setTimerDuration] = useState(60);
  const [sessionExpired, setSessionExpired] = useState(false);
  const dispatch = useDispatch();
  const lastActiveTime = useSelector((state: RootState) => state.sessionManager.lastActiveTime);
  const securityTokenExpired = useSelector((state: RootState) => state.sessionManager.expired);
  useEffect(() => {
    //clearAuthInfoFromStorage();

    const sessionCheckInterval = IDLE_TIMEOUT - 60000;
    setshowMessage(false);
    setShowTimer(false);
    setTimerDuration(60);
    setSessionExpired(false);
    const interval = window.setInterval(() => {
      const currTime = new Date();
      let timeDiff: number = currTime.getTime() - lastActiveTime.getTime();
      if (timeDiff >= sessionCheckInterval) {
        setshowMessage(true);
        setShowTimer(true);
        setSessionExpired(false);
      }
    }, sessionCheckInterval);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastActiveTime]);

  let timerInterval: any;
  let timeout: any;

  useEffect(() => {
    if (showTimer) {
      if (timerDuration > 0) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        timerInterval = window.setInterval(() => {
          setTimerDuration(timerDuration - 1);
        }, 1000);
      } else {
        setSessionExpired(true);
        clearAuthInfoFromStorage();
        clearTimeout(timerInterval);
        setShowTimer(false);
        setTimerDuration(60);
        window.location.href = '/';
      }
    }
    return () => {
      clearInterval(timerInterval);
      //clearTimeout(timeout);
    };
  }, [showTimer, timerDuration]);
  const extendSession = () => {
    setSessionExpired(false);
    clearTimeout(timeout);
    setshowMessage(false);
    dispatch(setNavigation());
  };
  const onLoginClicked = () => {
    let currentPage = window.location.href;
    currentPage = currentPage.substr(currentPage.lastIndexOf('/')).toLocaleLowerCase();
    if (
      currentPage === OFFER_ELIGIBILITY_PATH ||
      currentPage === OFFER_CONTACT_INFO_PATH ||
      currentPage === OFFER_REVIEW_PATH
    ) {
      sessionStorage.setItem('RESET_APP_STATE', 'N');
    }
    clearAuthInfoFromStorage();
    sessionStorage.setItem('LAST_VISITED_PAGE', currentPage);
    window.location.href = '/';
  };

  return (
    <>
      {securityTokenExpired && <SessionExpired onLoginClicked={onLoginClicked}></SessionExpired>}
      {showMessage && (
        <Alert variant="warning">
          <div className="container">
            {sessionExpired ? (
              <div className="row">
                <div className="md-col-12">
                  <span className="card-title">
                    {localize('preview-sales-engine.static-content.copy.associate-search-page.session-expired-message')}
                  </span>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="md-col-9">
                  <span className="card-title">
                    <ParseHtml
                      htmlInput={localize(
                        'preview-sales-engine.static-content.copy.associate-search-page.session-expiry-alert-message',
                        getHumanReadableTime(timerDuration),
                      )}
                    />{' '}
                  </span>
                </div>
                <div className="md-col-9">
                  <Button className="px-2 btn-link" onClick={extendSession}>
                    {localize(
                      'preview-sales-engine.static-content.copy.associate-search-page.click-here-to-continue-button',
                    )}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Alert>
      )}
    </>
  );
};
export default withLocalization(SessionManager);
